import { styled } from '@mui/material';

export const createStyledIcon = (
    IconComponent: React.ComponentType<React.SVGProps<SVGSVGElement>>,
    customStyles?: React.CSSProperties,
) =>
    styled(IconComponent)(({ theme }) => ({
        color: theme.palette.primary.main,
        padding: '2px',
        boxSizing: 'content-box',
        ...customStyles,
    }));
